import { apiClient } from './apiClient';

export const settingsService = {
    async getAutoCaseCreationList() {
        return apiClient.get('/settings/auto-case-creation');
    },

    async updateAutoCaseCreationList(addresses) {
        return apiClient.post('/settings/auto-case-creation', { addresses });
    },

    async getEmailSignature() {
        const response = await apiClient.get('/settings/email-signature');
        return response.data?.data ?? response.data;
    },

    async saveEmailSignature(payload) {
        const response = await apiClient.put('/settings/email-signature', { 
            text: payload.text, 
            html: payload.html,
            imageUrl: payload.imageUrl,
            enabled: payload.enabled 
        });
        return response.data?.data ?? response.data;
    },

    async getBillingAgentSettings() {
        const response = await apiClient.get('/settings/billing-agent');
        return response.data?.data ?? response.data ?? response;
    },

    async saveBillingAgentSettings(payload) {
        const response = await apiClient.post('/settings/billing-agent', payload);
        return response.data?.data ?? response.data ?? response;
    }
};
